/* RevitalGlow homepage helpers: flip circles, "#buy" scroll links, show more.
   Accordions (the FAQ section) are handled by assets/rg-accordion.js. */
(function () {
  if (window.rgHpBound) return;
  window.rgHpBound = true;

  function buyTarget() {
    return document.querySelector('[data-rg-hp-buy]') || document.querySelector('[data-section-type="product"]');
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-rg-hp-flip], a[href="#buy"], [data-rg-hp-more]');
    if (!el) return;

    if (el.hasAttribute('data-rg-hp-flip')) {
      var on = !el.classList.contains('is-flipped');
      /* One ingredient open at a time, same rule as the FAQ answers. */
      if (on) {
        var row = el.closest('.rg-hp-inside__row');
        if (row) {
          row.querySelectorAll('[data-rg-hp-flip].is-flipped').forEach(function (other) {
            if (other === el) return;
            other.classList.remove('is-flipped');
            other.setAttribute('aria-expanded', 'false');
          });
        }
      }
      el.classList.toggle('is-flipped', on);
      el.setAttribute('aria-expanded', on ? 'true' : 'false');
      return;
    }

    if (el.hasAttribute('data-rg-hp-more')) {
      var box = el.closest('[data-rg-hp-more-root]');
      if (!box) return;
      box.classList.add('is-expanded');
      box.querySelectorAll('[data-rg-hp-more]').forEach(function (b) { b.hidden = true; });
      return;
    }

    var t = buyTarget();
    if (!t) return;
    e.preventDefault();
    t.style.scrollMarginTop = '70px';
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();